import { useLang } from "../i18n/LangContext";
import { SectionHead, Reveal } from "./Reveal";

export const Houses = () => {
  const { t } = useLang();
  return (
    <section id="houses" data-testid="houses-section" className="px-6 md:px-12 py-28 md:py-40 bg-ink-2 border-y border-line">
      <SectionHead id="houses" over={t.houses.over} title={t.houses.title} title2={t.houses.title2} />
      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
        {t.houses.list.map((h, i) => (
          <Reveal key={h.city} delay={i * 0.12} className={i === 1 ? "md:mt-24" : ""}>
            <div className="group" data-testid={`house-card-${i}`}>
              <div className="relative aspect-[3/4] overflow-hidden">
                <img src={h.img} alt={h.city} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] [transition-duration:1200ms]" />
                <span className="absolute top-4 right-4 font-mono text-[11px] tracking-[0.16em] text-[var(--bone)] bg-[rgba(11,10,9,0.6)] backdrop-blur px-2 py-1">{h.coord}</span>
              </div>
              <div className="mt-6 flex items-baseline justify-between border-b border-line pb-5">
                <h3 className="font-display text-4xl md:text-5xl">{h.city}</h3>
                <span className="font-mono text-xs text-stone">0{i + 1}</span>
              </div>
              <p className="mt-4 eyebrow">{h.role}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
